import React, { useState } from 'react';
import GenericTable from 'shared/components/common/table/table';
import styles from './style.module.scss';
import { DownloadIcon, EditIcon, PlusIcon, ProjectNameIcon, StatusCheckIcon } from 'assets';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import UpdateInvenotyMod from 'shared/modal/update_inventory/UpdateInvenotyMod';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { isRestrictActions } from 'shared/utils/Helper';

const InnerInvenTable = ({ PoList, OffPage,SelectedPos,updateHandler }) => {
    const [openProduct, setOpenProduct] = useState(false);
    const [dataList, setdataList] = useState();
    const navigate = useNavigate();
    const [openinventory, setOpeninventory] = useState(false);

// naya array banao jisme supplier inject ho jaye
const dataWithSupplier = PoList?.map(item => ({
  ...item,
  supplier: SelectedPos?.supplier?.name || "", // safe chaining
}));

    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const views = (data) => {
        setOpenProduct(true);
        setdataList(data)
    };
      const edites = (data) => {
        setOpeninventory(true);
        setdataList(data);
    };
const closeProductHandler = () => setOpeninventory(false);

      const updateHandlerLocal = (payload) => {
            updateHandler(payload);

    setOpeninventory(false) // ✅ correct
    };
            console.log(PoList,"SelectedPos")

    const columns = React.useMemo(
        () => [
               {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Supplier
                    </div>
                ),
                accessor: 'supplier',
                Cell: ({ row }) => <div>{row.original?.supplier}</div>
            },
             {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        SKU
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div>{row.original?.sku}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product
                    </div>
                ),
                accessor: 'as',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Category
                    </div>
                ),
                accessor: 'categorys',
                Cell: ({ row }) => <div>{row.original?.product_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Sub Categ.
                    </div>
                ),
                accessor: 'subCategory',
                Cell: ({ row }) => <div>{row.original?.sub_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Brand
                    </div>
                ),
                accessor: 'brands',
                Cell: ({ row }) => <div>{row.original.brand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Quantity
                    </div>
                ),
                accessor: 'quantity',
                Cell: ({ row }) => <div>{row.original.quantity}</div>
            },
             {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <EditIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Update
                    </div>
                ),
                accessor: 'view&print',
                Cell: ({ row }) => <EditIcon onClick={() =>{
                    if (isRestrictActions(screenEnum.inventory, screenActionEnum.update)) {

                        edites(row?.original)
                    }
                }} />
            }
            // {
            //     Header: (
            //         <div className={classNames(`${theme}FontColor`)}>
            //             <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
            //             Change Item QTY
            //         </div>
            //     ),
            //     accessor: 'view&print',
            //     Cell: ({ row }) => <EditIcon onClick={() => views(row?.original)} />
            // }
        ],

        [theme]
    );
    return (
        <div className={'text-start'}>
            <div className={styles.Header}>
                <Heading heading={'Selected PO Items'} headingStyle={styles.Heading} />
            </div>
            <GenericTable columns={columns} OffPage={OffPage} data={dataWithSupplier || []} TableWrapperStyle={classNames(styles.Table)} />
            <UpdateInvenotyMod outnot={'true'} show={openinventory}  handleClose={closeProductHandler} data={dataList} updateHandler={updateHandlerLocal} />

        </div>
    );
};

export default InnerInvenTable;
